<template>
    <div class="index-side">
        <img src="../resource/img/sidebar.png"/>
    </div>
</template>

<script>
export default {
name: "sider"
}
</script>

<style scoped>
    .index-side {
        position: fixed;
        right: 0;
        bottom: 0;
    }
</style>
